// FLAG:useDocuAi — plan omxweb-draft-receipt-instead-of-review-row T23: a file uploaded INTO an
// open receipt form is linked to that receipt the moment the upload finishes, not only when the
// form is saved.
//
// The gap it closes (measured 2026-09-18 on expense 12532): the speed dial's upload goes through
// the legacy FineUploader, which stamps no upload intent, so the server creates no record and the
// link is made by the SAVE (expenseService assignFiles). Leaving the form with the back arrow
// therefore left the document in DMS belonging to nobody — reported as „im dms bleibt das
// dokument, öffnet man die ausgabe ist nur das ursprüngliche da".
//
// Deliberately NOT the receipt update endpoint: the open form holds unsaved edits, and attaching a
// document must not persist them behind the user's back. The endpoints touch only the link.
//
// Flag-OFF calls this never (the caller checks useDocuAi), and the server refuses to link without
// the flag as well — so the legacy „assign on save" behaviour stays exactly as it was.
import request from '@/modules/base/util/request'
import globalConfig from '@/config'
import expenseConfig from '@/modules/expense/config'
import revenueConfig from '@/modules/revenue/config'
import { RECEIPT_TYPES } from '@/modules/base/util/constants'

export interface AttachUploadedReceiptParams {
  /** RECEIPT_TYPES.EXPENSE | RECEIPT_TYPES.REVENUE — which ledger the open form belongs to. */
  type: string
  /** The receipt currently open. Without one (a form that has never been saved) there is nothing to link to. */
  receiptId?: number | string | null
  fileId?: number | string | null
}

export const canAttachUploadedReceipt = (
  { receiptId, fileId }: AttachUploadedReceiptParams,
): boolean => !!receiptId && !!fileId

export const attachUploadedReceipt = async(
  { type, receiptId, fileId }: AttachUploadedReceiptParams,
): Promise<boolean> => {
  if (!canAttachUploadedReceipt({ type, receiptId, fileId })) { return false }

  // `urls.resource` is the one both configs expose (revenue has no top-level resourceUrl).
  const resourceUrl = type === RECEIPT_TYPES.REVENUE ? revenueConfig.urls.resource : expenseConfig.urls.resource
  await request(`${resourceUrl}/${receiptId}/receipt`, {
    auth: true,
    isConcurrent: true,
    timeout: globalConfig.requestExtraLongTimeout,
    method: 'POST',
    data: { fileId: Number(fileId) },
  })
  return true
}
